const settings = {
  isSplash: true, // Change this to false if you don't want Splash screen.
};

//SEO Related settings
const seo = {
  title: "Nurnaby Siddiqui | Portfolio",
  description:
    "A full stack web developer who thrives to leverage startups with AI based solutions with a blend of UI/UX",
  og: {
    title: "Nurnaby Portfolio",
    type: "website",
    url: "http://nurnabysiddiqui.com/",
  },
};

//Home Page
const greeting = {
  title: "Assalamualaikum!",
  sub: "Nurnaby Siddiqui",
  logo_name: "Nurnaby Siddiqui",
  resumeLink:
    "https://drive.google.com/file/d/1CjyVZxWg_irVUXAR4znJHOqe1b2olPaY/view?usp=sharing",
};

// home logos
const competitiveSites = {
  competitiveSites: [
    {
      siteName: "Github",
      iconifyClassname: "simple-icons:github",
      style: {
        color: "white",
      },
      profileLink: "https://github.com/Siddiqui-2583",
    },
    {
      siteName: "Research Gate",
      iconifyClassname: "simple-icons:researchgate",
      style: {
        color: "#00CCBB",
      },
      profileLink: "https://www.researchgate.net/profile/Nurnaby-Shourav",
    },
    {
      siteName: "LinkedIn",
      iconifyClassname: "simple-icons:linkedin",
      style: {
        color: "#0077b5",
      },
      profileLink: "https://www.linkedin.com/in/nurnaby-siddiqui/",
    },
    {
      siteName: "Gmail",
      iconifyClassname: "simple-icons:gmail",
      style: {
        color: "#BA3329",
      },
      profileLink:
        "https://mail.google.com/mail/?view=cm&fs=1&to=nurnaby@gmail.com",
    },
    {
      siteName: "Skype",
      iconifyClassname: "simple-icons:skype",
      style: {
        color: "#00AFF0",
      },
      profileLink: "https://join.skype.com/invite/z7J7Kd8tnWXs",
    },
  ],
};

//what i do?
const skills = {
  data: [
    // {
    //   title: "Data Science & Analysis",
    //   fileName: "DataScienceImg",
    //   skills: [
    //     "⚡ Developing highly scalable production-ready models for various deep learning and statistical use cases",
    //     "⚡ Experience in working with Computer Vision using OpenCV and NLP projects(T5-Transformer & OpenAI)",
    //     "⚡ Having good hands-on with Data Cleaning, processing & Analysing using Pandas, Tableau & PowerBI",
    //     "⚡ Experience with Text-to-speech encoders/decoders (speech synthesis) & Voice Cloning",
    //   ],
    //   softwareSkills: [
    //     {
    //       skillName: "Tensorflow",
    //       fontAwesomeClassname: "logos-tensorflow",
    //       style: {
    //         backgroundColor: "transparent",
    //       },
    //     },
    //     {
    //       skillName: "PyTorch",
    //       fontAwesomeClassname: "logos-pytorch",
    //       style: {
    //         backgroundColor: "transparent",
    //       },
    //     },
    //     {
    //       skillName: "Python",
    //       fontAwesomeClassname: "ion-logo-python",
    //       style: {
    //         backgroundColor: "transparent",
    //         color: "#3776AB",
    //       },
    //     },
    //     {
    //       skillName: "Pandas",
    //       fontAwesomeClassname: "simple-icons:pandas",
    //       style: {
    //         backgroundColor: "transparent",
    //         color: "#3776AB",
    //       },
    //     },
    //     {
    //       skillName: "NumPy",
    //       fontAwesomeClassname: "logos-numpy",
    //       style: {
    //         backgroundColor: "transparent",
    //       },
    //     },
    //     {
    //       skillName: "Tableau",
    //       fontAwesomeClassname: "logos-tableau",
    //       style: {
    //         backgroundColor: "transparent",
    //       },
    //     },
    //   ],
    // },
    {
      title: "Web Development",
      fileName: "FullStackImg",
      skills: [
        "⚡ I can build complete web applications in MERN stack",
        "⚡ I have clear understanding of REST APIs",
        "⚡ I follow design patterns like MVC",
        "⚡ I am used to version controlling using Git",
        "⚡ I have deployment experience in Netlify, Heroku & namecheap",
      ],
      softwareSkills: [
        {
          skillName: "HTML5",
          fontAwesomeClassname: "simple-icons:html5",
          style: {
            color: "#E34F26",
          },
        },
        {
          skillName: "CSS3",
          fontAwesomeClassname: "fa-css3",
          style: {
            color: "#1572B6",
          },
        },
        // {
        //   skillName: "Sass",
        //   fontAwesomeClassname: "simple-icons:sass",
        //   style: {
        //     color: "#CC6699",
        //   },
        // },
        {
          skillName: "BootStrap",
          fontAwesomeClassname: "logos-bootstrap",
          style: {
            color: "#CC6699",
          },
        },
        {
          skillName: "Material UI",
          fontAwesomeClassname: "logos-material-ui",
          style: {
            color: "#CC6699",
          },
        },
        {
          skillName: "Tailwind CSS",
          fontAwesomeClassname: "logos-tailwindcss-icon",
          style: {
            color: "#CC6699",
          },
        },
        {
          skillName: "JavaScript",
          fontAwesomeClassname: "simple-icons:javascript",
          style: {
            backgroundColor: "#000000",
            color: "#F7DF1E",
          },
        },
        {
          skillName: "MongoDB",
          fontAwesomeClassname: "simple-icons:mongodb",
          style: {
            color: "#10AA50",
          },
        },
        {
          skillName: "ExpressJS",
          fontAwesomeClassname: "simple-icons:express",
          style: {
            color: "#BDBDBD",
          },
        },
        {
          skillName: "ReactJS",
          fontAwesomeClassname: "simple-icons:react",
          style: {
            color: "#61DAFB",
          },
        },
        {
          skillName: "NodeJS",
          fontAwesomeClassname: "simple-icons:node-dot-js",
          style: {
            color: "#339933",
          },
        },
        {
          skillName: "NPM",
          fontAwesomeClassname: "simple-icons:npm",
          style: {
            color: "#CB3837",
          },
        },
      ],
    },
    // {
    //   title: "UI/UX Design",
    //   fileName: "DesignImg",
    //   skills: [
    //     "⚡ Designing highly attractive user interfaces for mobile and web applications",
    //     "⚡ Customizing logo designs and building logos from scratch",
    //     "⚡ Creating the flow of application functionalities to optimize user experience",
    //     "⚡ Applying latest Design principles and experienced in product wireframing",
    //   ],
    //   softwareSkills: [
    //     {
    //       skillName: "Adobe XD",
    //       fontAwesomeClassname: "simple-icons:adobexd",
    //       style: {
    //         color: "#FF2BC2",
    //       },
    //     },
    //     {
    //       skillName: "Adobe Illustrator",
    //       fontAwesomeClassname: "simple-icons:adobeillustrator",
    //       style: {
    //         color: "#FF7C00",
    //       },
    //     },
    //     {
    //       skillName: "Adobe Photoshop",
    //       fontAwesomeClassname: "simple-icons:adobephotoshop",
    //       style: {
    //         color: "#2fa3f7",
    //       },
    //     },
    //     {
    //       skillName: "Figma",
    //       fontAwesomeClassname: "simple-icons:figma",
    //       style: {
    //         color: "#F24E1E",
    //       },
    //     },
    //   ],
    // },
  ],
};

// Projects Page
const projectsHeader = {
  title: "My works",
  description:
    "I really love the world of software development. Because it helps me to be a part of making a visionary idea into reality.",
};

//project cards
// colors:[primary,secondary,success,danger,warning,info,light,dark,]
const projectcards = {
  list: [
    {
      title: "LMS",
      img_path: "lms.gif",
      description:
        "A library management system developed in MERN stack and deployed in Heroku",
      tags: [
        {
          lang: "MongoDB",
          color: "#409042",
        },
        {
          lang: "ExpressJS",
          color: "#303030",
        },
        {
          lang: "ReactJS",
          color: "#61DBFB",
        },
        {
          lang: "NodeJS",
          color: "#4F8D4B",
        },
        {
          lang: "Heroku",
          color: "#3c0095",
        },
      ],
      link: "https://app-ajml.herokuapp.com",
      code:
        "https://github.com/Siddiqui-2583/Library-Management-System-with-MERN",
      linkcolor: "white",
    },

    {
      title: "Acuisto-api",
      img_path: "acquisto-api.gif",
      description:
        "An API made for a real estate broker's website where property data was imported from various mls APIs",
      tags: [
        {
          lang: "MongoDB",
          color: "#409042",
        },
        {
          lang: "ExpressJS",
          color: "#303030",
        },
        {
          lang: "NodeJS",
          color: "#ff4b4b",
        },
        {
          lang: "Heroku",
          color: "#3c0095",
        },
      ],
      link: "",
      code: "",
      linkcolor: "white",
    },
    {
      title: "Joloj",
      img_path: "joloj.png",
      description:
        "A water monitoring system dashboard built with eJS and NodeJS",
      tags: [
        {
          lang: "MongoDB",
          color: "#409042",
        },
        {
          lang: "ExpressJS",
          color: "#303030",
        },
        {
          lang: "eJS",
          color: "#00a100",
        },
        {
          lang: "NodeJS",
          color: "#ff4b4b",
        },
        {
          lang: "Heroku",
          color: "#3c0095",
        },
      ],
      link: "",
      code: "https://github.com/Siddiqui-2583/Joloj",
      linkcolor: "white",
    },
    {
      title: "Emma-john-simple",
      img_path: "emma-john.png",
      description:
        "A mini clone Amazon built in ReactJS and deployed in Netlify",
      tags: [
        {
          lang: "ReactJS",
          color: "#61DBFB",
        },
        {
          lang: "Fakedata",
          color: "#ff4b4b",
        },
        {
          lang: "HTML",
          color: "#ff4b4b",
        },
      ],
      link: "https://emmajohn-simple.netlify.app/",
      code: "https://github.com/Siddiqui-2583/emma-john-simple",
      linkcolor: "white",
    },

    {
      title: "Red-store front-end",
      img_path: "red-store.png",
      description:
        "A mini e-commerce app developed in ReactJS without styling library/framework and deployed in Netlify",
      tags: [
        {
          lang: "MongoDB",
          color: "#409042",
        },
        {
          lang: "ExpressJS",
          color: "#303030",
        },
        {
          lang: "ReactJS",
          color: "#61DBFB",
        },
        {
          lang: "NodeJS",
          color: "#4F8D4B",
        },
        {
          lang: "Netlify",
          color: "#3AADBC",
        },
      ],
      link: "https://red-store-83.netlify.app/",
      code: "https://github.com/Siddiqui-2583/Red-store-frontend",
      linkcolor: "white",
    },

    {
      title: "Red-store API",
      img_path: "red-store.png",
      description:
        "An API for mini e-commerce app developed in NodeJS without and deployed in Heroku",
      tags: [
        {
          lang: "MongoDB",
          color: "#409042",
        },
        {
          lang: "ExpressJS",
          color: "#303030",
        },
        {
          lang: "NodeJS",
          color: "#4F8D4B",
        },
        {
          lang: "Netlify",
          color: "#3AADBC",
        },
      ],
      link: "https://red-store-83.netlify.app/",
      code: "https://github.com/Siddiqui-2583/red-store-api",
      linkcolor: "white",
    },

    // {
    //   title: "Hungry-monster",
    //   img_path: "project-02.png",
    //   description:
    //     "A python streamlit webapp to automate generating & uploading youtube thumbnails using Youtube v3 API",
    //   tags: [
    //     {
    //       lang: "internal project",
    //       color: "red",
    //     },
    //     {
    //       lang: "youtube v3 api",
    //       color: "red",
    //     },
    //   ],
    //   link: "",
    //   code: "",
    //   linkcolor: "white",
    // },

    {
      title: "Pioneer-bank",
      img_path: "pioneer-bank.gif",
      description:
        "A simple transaction calculation app developed with html,css,bootstrap and vanilla javascript",
      tags: [
        {
          lang: "HTML",
          color: "#eb4d4b",
        },
        {
          lang: "CSS",
          color: "#22a6b3",
        },
        {
          lang: "Bootstrap",
          color: "#7952B3",
        },
        {
          lang: "Javascript",
          color: "#f9ca24",
        },
      ],
      link: "https://siddiqui-2583.github.io/Pioneer-bank/",
      code: "https://github.com/Siddiqui-2583/Pioneer-bank",
      linkcolor: "white",
    },

    {
      title: "Bus-ticket",
      img_path: "bus-ticket.gif",
      description:
        "A simple bus ticket add to cart app developed with raw html,css and vanilla javascript and deployed with github pages.",
      tags: [
        {
          lang: "HTML",
          color: "#eb4d4b",
        },
        {
          lang: "CSS",
          color: "#22a6b3",
        },
        {
          lang: "Bootstrap",
          color: "#7952B3",
        },
        {
          lang: "Javascript",
          color: "#f9ca24",
        },
      ],
      link: "https://siddiqui-2583.github.io/bus-ticket/",
      code: "https://github.com/Siddiqui-2583/bus-ticket",
      linkcolor: "white",
    },

    {
      title: "Quicky-backpack",
      img_path: "quicky-backpack.png",
      description:
        "A ui of a backpack shop developed with raw html,css and bootstrap and deployed with github pages.",
      tags: [
        {
          lang: "HTML",
          color: "#eb4d4b",
        },
        {
          lang: "CSS",
          color: "#22a6b3",
        },
        {
          lang: "Bootstrap",
          color: "#7952B3",
        },
      ],
      link: "https://siddiqui-2583.github.io/quicky-backpack/",
      code: "https://github.com/Siddiqui-2583/quicky-backpack",
      linkcolor: "white",
    },
  ],
};



const resumeleft = {
  left: [
    {
      title: ["Education"],
      data: [
        {
          title: "BSc in Computer Science and Engineering",
          subtitle: "Ahsanullah University of Science and Technology",
          date: "2017 - 2021",
          content: ["CGPA: 2.8"],
        },
        {
          title: "Higher Secondary Certificate [HSC]",
          subtitle: "Mirzapur Cadet College",
          date: "2015 - 2016",
          content: ["GPA: 5"],
        },
        {
          title: "Secondary School Certificate [SSC]",
          subtitle: "Mirzapur Cadet College",
          date: "2013 - 2014",
          content: ["GPA: 5"],
        },
      ],
    },
    {
      title: ["Achivements"],
      data: [
        {
          title: "The Duke of Edinburgh's International Award",
          content: ["The Bronze Standard"],
        },
        {
          title: "Beamline for Schools Competition",
          content: [
            "Enlisted among the 31 top rated teams by CERN Scientific Jury",
          ],
        },
        {
          title: "BYLC Youth Entrepreneurship Challenge",
          content: ["Enlisted among top 100 startup in whole Bangladesh"],
        },
        {
          title: "Student to Startup competition by ICT division, Bangladesh",
          content: ["Enlisted among top 100 startup in whole Bangladesh"],
        },
      ],
    },
    
  ],
};


const resumeright = {
  right: [
    {
      title: ["Experience"],
      data: [
        {
          title: "Software Engineer",
          subtitle: "SELISE Digital Platform",
          date: "Jul 2022 - Present",
          content: [
            "Mainly I am working as a front-end developer here.",
            "As a front-end developer, I am working with ReactJs, Redux, NextJs, Material Ui, Tailwind css etc.",
            
          ],
        },
        {
          title: "Software Engineer",
          subtitle: "Sweet iTech",
          date: "Oct 2021 - Jun 2022",
          content: [
            "Mainly I am working as a front-end developer here.",
            "As a front-end developer, I am working with ReactJs, Redux, NextJs, Material Ui, Tailwind css etc.",
            
          ],
        },
        // {
        //   title: "Chief Technology Officer",
        //   subtitle: "Dealdone",
        //   date: "Jan 2021 - Jun 2021",
        //   content: [
        //     "Since it was a startup, I had to do coding as well as lead a small tech team.",
        //     "I had to design the UI/UX considering all the business case.",
        //     "Basically I worked on the frontend part which was in ReactJS",
        //     "The technology stack was MERN",
        //   ],
        // }
      ],
    },

    {
      title: ["Freelance Work"],
      data: [
        {
          title: "Abdul Jalil LMS",
          subtitle: "Library Management System",
          content: [
            "Developed this library management system in MERN stack and deployed in Heroku",
          ],
        },
        {
          title: "Deshishodai",
          subtitle: "deshishodai.xyz",
          content: [
            "Developed this e-commerce website of deshi products in Wordpress and deployed buying domain-hosting from Namecheap",
          ],
        },
        {
          title: "Mohanagar Super Shop",
          subtitle: "mohanagar.shop",
          content: [
            "Developed this super shop website in Wordpress and deployed buying domain-hosting from Namecheap",
          ],
        },
        {
          title: "Chakka Courier",
          subtitle: "chakkacourier.com",
          content: [
            "Developed this courier delivery service website in Wordpress and deployed buying domain-hosting from Namecheap",
          ],
        },
      ],
    },
  ],
};

//certificate cards
const certifications = {
  certifications: [
    {
      title: "Tableau Analyst",
      subtitle: "Tableau",
      logo_path: "tabana-01.png",
      certificate_link:
        "https://www.credly.com/badges/2d43f401-7be0-407d-9a77-7477dda8cade/linked_in_profile",
      alt_name: "Tableau",
      color_code: "#000000",
    },
    {
      title: "Tableau Consumer",
      subtitle: "Tableau",
      logo_path: "tabcon-01.png",
      certificate_link:
        "https://www.credly.com/badges/e5befe7b-2eec-486f-b77e-bd2458c18b26/linked_in_profile",
      alt_name: "Tableau",
      color_code: "#000000",
    },
    {
      title: "Problem solving",
      subtitle: "HackerRank",
      logo_path: "problem-01.png",
      certificate_link: "https://www.hackerrank.com/rohankokkula",
      alt_name: "HackerRank",
      color_code: "#000000",
    },
    {
      title: "Python",
      subtitle: "HackerRank",
      logo_path: "python-01.png",
      certificate_link: "https://www.hackerrank.com/rohankokkula",
      alt_name: "HackerRank",
      color_code: "#000000",
    },
    {
      title: "Certificate of Merit",
      subtitle: "Summer Analytics | IIT Guwahati",
      logo_path: "iitg-01.png",
      certificate_link:
        "https://www.coursera.org/account/accomplishments/verify/22MTSSC5WDTM",
      alt_name: "IITG",
      color_code: "#000000",
    },
    {
      title: "Tableau Desktop Qualified Associate",
      subtitle: "SimpliLearn",
      logo_path: "simplilearn-01.png",
      certificate_link:
        "https://www.coursera.org/account/accomplishments/verify/22MTSSC5WDTM",
      alt_name: "Simplilearn",
      color_code: "#000000",
    },
    {
      title: "Question Generation using Transformers",
      subtitle: "Udemy",
      logo_path: "udemy-01.png",
      certificate_link:
        "https://www.udemy.com/certificate/UC-b17c4c21-91e3-4f8b-b9c2-259468910985/",
      alt_name: "Udemy",
      color_code: "#000000",
    },
    {
      title: "Machine Learning",
      subtitle: "Stanford University",
      logo_path: "coursera-01.png",
      certificate_link:
        "https://www.coursera.org/account/accomplishments/verify/22MTSSC5WDTM",
      alt_name: "Stanford University",
      color_code: "#000000",
    },
    {
      title: "Data Visualization",
      subtitle: "University of Michigan",
      logo_path: "coursera-01.png",
      certificate_link:
        "https://www.coursera.org/account/accomplishments/verify/22MTSSC5WDTM",
      alt_name: "University of Michigan",
      color_code: "#000000",
    },
    {
      title: "Data Scientist Career Track",
      subtitle: "DataCamp",
      logo_path: "datacamp-01.png",
      certificate_link:
        "https://www.datacamp.com/statement-of-accomplishment/track/29f2ddab3fbfd0a470713a19c729c0f9d89c88aa",
      alt_name: "DataCamp",
      color_code: "#000000",
    },
    {
      title: "PowerBI Masters",
      subtitle: "iNeuron.ai",
      logo_path: "ineuron-01.png",
      certificate_link:
        "https://academy.ineuron.ai/certificates/downloads/PB009929.pdf",
      alt_name: "HackerRank",
      color_code: "#000000",
    },
    {
      title: "Tableau Masters",
      subtitle: "iNeuron.ai",
      logo_path: "ineuron-01.png",
      certificate_link:
        "https://academy.ineuron.ai/certificates/downloads/TB000634.pdf",
      alt_name: "HackerRank",
      color_code: "#000000",
    },
  ],
};

// Contact Page
const contactPageData = {
  contactSection: {
    title: "Contact Me",
    profile_image_path: "contact.jpg",
    description:
      "I am available on almost every social media. Feel free to knock me anytime.",
  },
  addressSection: {
    title: "Address",
    subtitle: "Hatirpool, Dhaka",
  },
  phoneSection: {
    title: "Phone Number",
    subtitle: "+8801788261776",
  },
};

//contact icons
const socialMediaLinks = [
  {
    name: "Github",
    link: "https://github.com/Siddiqui-2583",
    iconifyClassname: "simple-icons:hackerrank",
    fontAwesomeIcon: "fa-github", // Reference https://fontawesome.com/icons/github?style=brands
    backgroundColor: "#181717", // Reference https://simpleicons.org/?q=github
  },
  {
    name: "LinkedIn",
    link: "https://www.linkedin.com/in/nurnaby-siddiqui/",
    fontAwesomeIcon: "fa-linkedin-in", // Reference https://fontawesome.com/icons/linkedin-in?style=brands
    backgroundColor: "#0077B5", // Reference https://simpleicons.org/?q=linkedin
  },
  {
    name: "Skype",
    link: "https://join.skype.com/invite/z7J7Kd8tnWXs",
    fontAwesomeIcon: "fa-skype", // Reference https://fontawesome.com/icons/youtube?style=brands
    backgroundColor: "#00AFF0", // Reference https://simpleicons.org/?q=youtube
  },
  {
    name: "Gmail",
    link: "mailto:nurnaby83@gmail.com",
    fontAwesomeIcon: "fa-google", // Reference https://fontawesome.com/icons/google?style=brands
    backgroundColor: "#EA4335", // Reference https://simpleicons.org/?q=gmail
  },
];

export {
  settings,
  seo,
  greeting,
  socialMediaLinks,
  skills,
  competitiveSites,
  projectsHeader,
  contactPageData,
  projectcards,
  certifications,
  resumeleft,
  resumeright,
};
